"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _commonReact = require("@devsta/common-react");

var _reactApollo = require("react-apollo");

var _withBasedRouter = _interopRequireDefault(require("@devsta/with-based-router"));

var _reactSizeme = require("react-sizeme");

var _basePath = _interopRequireDefault(require("../../../common/constants/basePath"));

var _CompletedVideo = _interopRequireDefault(require("../components/CompletedVideo"));

var _api = require("../api");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function CompletedVideo(_ref) {
  var match = _ref.match,
      history = _ref.history;
  var _match$params = match.params,
      videoId = _match$params.videoId,
      outputId = _match$params.outputId;
  return /*#__PURE__*/_react.default.createElement(_commonReact.RequestProvider, {
    requests: {
      getVideo: (0, _api.getVideoQuery)(videoId),
      setUserRating: (0, _api.setUserRatingQuery)(outputId),
      getOutputRating: (0, _api.getOutputRatingQuery)(outputId),
      getEditor: (0, _api.getEditorQuery)(),
      updateInspiration: (0, _api.updateInspirationApi)(),
      getInspiration: (0, _api.getInspirationApi)()
    }
  }, function (_ref2) {
    var getVideo = _ref2.getVideo,
        setUserRating = _ref2.setUserRating,
        getOutputRating = _ref2.getOutputRating,
        getEditor = _ref2.getEditor,
        updateInspiration = _ref2.updateInspiration,
        getInspiration = _ref2.getInspiration;
    return /*#__PURE__*/_react.default.createElement(_commonReact.UploaderConsumer, null, function (_ref3) {
      var fetchAssets = _ref3.fetchAssets;
      return /*#__PURE__*/_react.default.createElement(_commonReact.CollaborationProvider, {
        resourceId: videoId,
        resourceName: "Video"
      }, /*#__PURE__*/_react.default.createElement(_commonReact.CollaborationConsumer, null, function (_ref4) {
        var fetchCollaborationData = _ref4.fetchCollaborationData,
            showShareModal = _ref4.showShareModal;
        return /*#__PURE__*/_react.default.createElement(_reactApollo.ApolloConsumer, null, function (apiClient) {
          return /*#__PURE__*/_react.default.createElement(_commonReact.AuthorisationConsumer, null, function (_ref5) {
            var organisationMemberships = _ref5.organisationMemberships,
                permissions = _ref5.selectedOrganisation.permissions;
            return /*#__PURE__*/_react.default.createElement(_reactSizeme.SizeMe, null, function (_ref6) {
              var size = _ref6.size;
              return /*#__PURE__*/_react.default.createElement(_CompletedVideo.default, {
                getVideo: getVideo,
                outputId: outputId,
                fetchAssets: fetchAssets,
                setUserRating: setUserRating,
                getOutputRating: getOutputRating,
                fetchCollaborationData: fetchCollaborationData,
                showShareModal: showShareModal,
                getEditor: getEditor,
                apiClient: apiClient,
                history: history,
                updateInspiration: updateInspiration,
                getInspiration: getInspiration,
                orgPermissions: permissions,
                membershipOrgIds: organisationMemberships.map(function (_ref7) {
                  var organisation = _ref7.organisation;
                  return organisation.organisationId;
                }),
                size: size
              });
            });
          });
        });
      }));
    });
  });
}

var _default = (0, _withBasedRouter.default)(_basePath.default, /*#__PURE__*/(0, _react.memo)(CompletedVideo));

exports.default = _default;